import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnsynchronized = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4713 5.16402C12.6611 4.25856 11.5951 3.6204 10.4143 3.334C9.23354 3.04759 7.99362 3.12642 6.85861 3.56006C5.7236 3.9937 4.74699 4.76171 4.05798 5.7625C3.36898 6.76328 3.00005 7.94966 3 9.16469V9.66669",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.52856 13.166C5.33873 14.0714 6.40468 14.7095 7.5854 14.9959C8.76613 15.2824 10.006 15.2036 11.141 14.77C12.276 14.3365 13.2526 13.5686 13.9416 12.5679C14.6307 11.5672 14.9997 10.3809 14.9999 9.16596V8.66663",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 10.1647L15 8.66467L16.5 10.1647",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 8.16467L3 9.66467L1.5 8.16467",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 5.66467V9.66467",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 11.6666C8.95055 11.6666 8.90222 11.6813 8.86111 11.7088C8.82 11.7362 8.78795 11.7753 8.76903 11.821C8.75011 11.8666 8.74516 11.9169 8.7548 11.9654C8.76445 12.0139 8.78826 12.0584 8.82322 12.0934C8.85819 12.1284 8.90273 12.1522 8.95123 12.1618C8.99972 12.1715 9.04999 12.1665 9.09567 12.1476C9.14135 12.1287 9.1804 12.0966 9.20787 12.0555C9.23534 12.0144 9.25 11.9661 9.25 11.9166C9.25 11.8503 9.22366 11.7867 9.17678 11.7398C9.12989 11.693 9.0663 11.6666 9 11.6666",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgUnsynchronized);
export default ForwardRef;
